import React from 'react'
import { Blocks, BriefcaseBusiness } from 'lucide-react'
import { InfiniteMovingCards } from './components/ui/infinite-moving-cards.jsx';
import mobilePOS from '../assets/mobile-pos.png'
import ecommerce from '../assets/ecommerce.png'
import ims from '../assets/ims.png'
import studentManagementSystem from '../assets/student-management-system.png'
import {useOutsideClick} from '../hooks/use-outside-click.ts'
import { AnimatePresence, motion } from "framer-motion";
import { CardBody, CardContainer, CardItem } from "./components/ui/3d-card.tsx";
import {
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalTrigger,
} from "./components/ui/animated-modal.tsx";

function Projects() {
    const [active, setActive] = React.useState(false);
    const id = React.useId();
    const ref = React.useRef();
    
    React.useEffect(() => {
    function onKeyDown(event) {
        if (event.key === "Escape") {
        setActive(false);
        }
    }
    
    if (active && typeof active === "object") {
        document.body.style.overflow = "hidden";
    } else {
        document.body.style.overflow = "auto";
    }
    
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
    }, [active]);
    
    useOutsideClick(ref, () => setActive(null));

    const CloseIcon = () => {
        return (
            <svg initial={{ opacity: 0, }} animate={{ opacity: 1, }} exit={{ opacity: 0, transition: { duration: 0.05, }, }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 text-black" > <path stroke="none" d="M0 0h24v24H0z" fill="none" /> <path d="M18 6l-12 12" /> <path d="M6 6l12 12" /> </svg>
        );
    };
    
    return (
        <div className="p-3 relative w-full rounded-lg">
            <div className='flex items-center gap-2 relative'>
                <BriefcaseBusiness className='w-5 h-5 text-blue-500' />
                <h1 className='text-lg font-bold'>My Projects</h1>
            </div>
            <p className='text-sm text-gray-300'>Here are some of the projects I worked on</p>
                <div className="mt-5 flex flex-col items-center relative z-[9999]">
                    <AnimatePresence>
                        {active && typeof active === "object" && (
                        <div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className="fixed inset-0 bg-black/20 h-full w-full z-10"
                        />
                        )}
                    </AnimatePresence>
                    <AnimatePresence>
                        {active && typeof active === "object" ? (
                        <div className="fixed inset-0  grid place-items-center z-[100]">
                            <button
                            key={`button-${active.title}-${id}`}
                            layout
                            initial={{
                                opacity: 0,
                            }}
                            animate={{
                                opacity: 1,
                            }}
                            exit={{
                                opacity: 0,
                                transition: {
                                duration: 0.05,
                                },
                            }}
                            className="flex absolute top-2 right-2 lg:hidden items-center justify-center bg-white rounded-full h-6 w-6"
                            onClick={() => setActive(null)}
                            >
                            <CloseIcon />
                            </button>
                            <div
                            layoutId={`card-${active.title}-${id}`}
                            ref={ref}
                            className="w-full max-w-[500px]  h-full md:h-fit md:max-h-[90%]  flex flex-col bg-gray-950 sm:rounded-3xl overflow-hidden"
                            >
                            <div layoutId={`image-${active.title}-${id}`}>
                                <img
                                    priority
                                    width={100}
                                    height={100}
                                    src={active.src}
                                    alt={active.title}
                                    className="w-full aspect-video sm:rounded-tr-lg sm:rounded-tl-lg object-cover object-top"
                                />
                            </div>
                
                            <div>
                                <div className="flex justify-between items-start p-4">
                                    <div className="">
                                        <h3
                                            layoutId={`title-${active.title}-${id}`}
                                            className="font-medium text-white text-base"
                                        >
                                        {active.title}
                                        </h3>
                                        <p
                                            layoutId={`description-${active.description}-${id}`}
                                            className="text-white text-base"
                                        >
                                        {active.description}
                                        </p>
                                    </div>
                    
                                    {/* <a
                                        layout
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        href={active.ctaLink}
                                        target="_blank"
                                        className="px-4 py-3 text-sm rounded-full font-bold bg-blue-600 hover:bg-blue-500 duration-200 text-white"
                                    >
                                        {active.ctaText}
                                    </a> */}
                                </div>
                                <div className="pt-4 relative px-4">
                                <div
                                    layout
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    className="text-white text-xs md:text-sm lg:text-base h-40 md:h-fit pb-10 flex flex-col items-start gap-4 overflow-auto [mask:linear-gradient(to_bottom,white,white,transparent)] [scrollbar-width:none] [-ms-overflow-style:none] [-webkit-overflow-scrolling:touch]"
                                >
                                    {typeof active.content === "function"
                                    ? active.content()
                                    : active.content}
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        ) : null}
                    </AnimatePresence>
                    <ul className="max-w-2xl mx-auto w-full ">
                    <InfiniteMovingCards
                        components={cards.map((card) => (
                            <div 
                                key={card.title}
                                data={card}
                            >
                                <CardContainer
                                    className="cursor-pointer p-4 flex flex-col hover:bg-gray-950 rounded-xl"
                                >
                                    <CardBody>
                                        <div className='flex flex-col items-center'>
                                            <CardItem translateZ="100">
                                                <img src={card.src} alt={card.title} className="w-44 aspect-video rounded-lg object-cover object-top" />
                                            </CardItem>
                                            <CardItem translateZ="75">
                                                <h3 className="text-white font-semibold text-center text-base mt-2">{card.title}</h3>
                                            </CardItem>
                                            <CardItem translateZ="50">
                                                <p className="text-gray-400 text-center text-sm">{card.description}</p>
                                            </CardItem>
                                        </div>
                                    </CardBody>
                                </CardContainer>
                            </div>
                        ))}
                        direction="right"
                        speed="fast"
                        className="w-full"
                        onCardClick={(card) => setActive(card)}
                    />
                        
                    </ul>
                <div className='-mt-2'>
                    <Modal>
                        <ModalTrigger isCloseBtn={false} className="bg-slate-800 no-underline group cursor-pointer relative shadow-2xl shadow-zinc-900 rounded-full p-px text-xs font-semibold leading-6  text-white inline-block">
                            <span className="absolute inset-0 overflow-hidden rounded-full">
                            <span className="absolute inset-0 rounded-full bg-[image:radial-gradient(75%_100%_at_50%_0%,rgba(56,189,248,0.6)_0%,rgba(56,189,248,0)_75%)] opacity-0 transition-opacity duration-500 group-hover:opacity-100"></span>
                            </span>
                            <div className="relative flex space-x-2 items-center z-10 rounded-full bg-gray-950 py-0.5 px-4 ring-1 ring-white/10 ">
                                <span>View All Projects</span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" > <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M10.75 8.75L14.25 12L10.75 15.25" ></path> </svg>
                            </div>
                            <span className="absolute -bottom-0 left-[1.125rem] h-px w-[calc(100%-2.25rem)] bg-gradient-to-r from-emerald-400/0 via-emerald-400/90 to-emerald-400/0 transition-opacity duration-500 group-hover:opacity-40"></span>
                        </ModalTrigger>
                        <ModalBody className='bg-gray-900'>
                            <ModalContent className='overflow-auto lg:overflow-hidden'>
                                <AnimatePresence>
                                    {active && typeof active === "object" && (
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        className="fixed inset-0 bg-black/20 h-full w-full z-10"
                                    />
                                    )}
                                </AnimatePresence>
                                <AnimatePresence>
                                    {active && typeof active === "object" ? (
                                    <div className="fixed inset-0  grid place-items-center z-[100]">
                                        <motion.button
                                            key={`button-${active.title}-${id}`}
                                            layout
                                            initial={{
                                                opacity: 0,
                                            }}
                                            animate={{
                                                opacity: 1,
                                            }}
                                            exit={{
                                                opacity: 0,
                                                transition: {
                                                duration: 0.05,
                                                },
                                            }}
                                            className="flex absolute top-2 right-2 lg:hidden items-center justify-center bg-white rounded-full h-6 w-6"
                                            onClick={() => setActive(null)}
                                        >
                                            <CloseIcon />
                                        </motion.button>
                                        <motion.div
                                            layoutId={`card-${active.title}-${id}`}
                                            ref={ref}
                                            className="w-full max-w-[500px]  h-full md:h-fit md:max-h-[90%]  flex flex-col bg-gray-950 sm:rounded-3xl overflow-hidden"
                                        >
                                            <motion.div layoutId={`image-${active.title}-${id}`}>
                                                <img
                                                    priority
                                                    width={200}
                                                    height={200}
                                                    src={active.src}
                                                    alt={active.title}
                                                    className="w-full aspect-video lg:h-80 sm:rounded-tr-lg sm:rounded-tl-lg object-cover object-top"
                                                />
                                            </motion.div>
                                
                                            <div>
                                                <div className="flex justify-between items-start p-4">
                                                    <div className="">
                                                        <motion.h3
                                                            layoutId={`title-${active.title}-${id}`}
                                                            className="font-medium text-white text-base"
                                                        >
                                                            {active.title}
                                                        </motion.h3>
                                                        <motion.p
                                                            layoutId={`description-${active.description}-${id}`}
                                                            className="text-white text-base"
                                                        >
                                                            {active.description}
                                                        </motion.p>
                                                    </div>
                                                </div>
                                                <div className="pt-4 relative px-4">
                                                    <motion.div
                                                        layout
                                                        initial={{ opacity: 0 }}
                                                        animate={{ opacity: 1 }}
                                                        exit={{ opacity: 0 }}
                                                        className="text-white text-xs md:text-sm lg:text-base h-40 md:h-fit pb-10 flex flex-col items-start gap-4 overflow-auto [mask:linear-gradient(to_bottom,white,white,transparent)] [scrollbar-width:none] [-ms-overflow-style:none] [-webkit-overflow-scrolling:touch]"
                                                    >
                                                        {typeof active.content === "function"
                                                        ? active.content()
                                                        : active.content}
                                                    </motion.div>
                                                </div>
                                            </div>
                                        </motion.div>
                                    </div>
                                    ) : null}
                                </AnimatePresence>
                                <ul className="max-w-2xl mx-auto w-full grid grid-cols-1 md:grid-cols-2 items-start gap-4">
                                    {cards.map((card, index) => (
                                    <motion.div
                                        layoutId={`card-${card.title}-${id}`}
                                        key={card.title}
                                        onClick={() => setActive(card)}
                                        className="p-4 flex flex-col  hover:bg-gray-950 rounded-xl cursor-pointer"
                                    >
                                        <CardContainer>
                                            <CardBody className="flex gap-4 flex-col  w-full">
                                                <CardItem translateZ={100}>
                                                    <motion.div layoutId={`image-${card.title}-${id}`}>
                                                        <img
                                                        width={100}
                                                        height={100}
                                                        src={card.src}
                                                        alt={card.title}
                                                        className="w-full aspect-video  rounded-lg object-cover object-top"
                                                        />
                                                    </motion.div>
                                                </CardItem>
                                                <div className="flex justify-center items-center flex-col">
                                                    <CardItem translateZ={75}>
                                                        <motion.h3
                                                            layoutId={`title-${card.title}-${id}`}
                                                            className="font-medium text-white lg:text-center text-left text-base"
                                                        >
                                                            {card.title}
                                                        </motion.h3>
                                                    </CardItem>
                                                    <CardItem translateZ={50}>
                                                        <motion.p
                                                            layoutId={`description-${card.description}-${id}`}
                                                            className="text-gray-400 lg:text-center text-left text-base"
                                                        >
                                                            {card.description}
                                                        </motion.p>
                                                    </CardItem>
                                                </div>
                                            </CardBody>
                                        </CardContainer>
                                    </motion.div>
                                    ))}
                                </ul>


                            </ModalContent>
                            {/* <ModalFooter className="gap-4 bg-gray-900">
                                <ModalTrigger isCloseBtn={true} className="px-2 py-1 bg-gray-950 border-black border rounded-md text-sm w-28">
                                    Close
                                </ModalTrigger>
                            </ModalFooter> */}
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        </div>
    )
}

const cards = [
    {
        title: "Mobile POS",
        description: "A project built with Flutter",
        src: mobilePOS,
        ctaText: "View Project",
        ctaLink: "#",
        content: "Built with Flutter and Firebase, this mobile POS and inventory management system offers a scalable and reliable platform. Integrate with our system to add POS and inventory functionality to your own projects.",
    },
    {
        title: "TamaTrack",
        description: "Student Management System",
        src: studentManagementSystem,
        ctaText: "View Project",
        ctaLink: "#",
        content: "This student management system offers a complete suite of tools for managing student data, including enrollment, attendance, grades, communication, and reporting. Improve efficiency and enhance the educational experience with our powerful solution.",
    },
    {
        title: "AgriLink",
        description: "An ecommerce website built with PHP",
        src: ecommerce,
        ctaText: "View Project",
        ctaLink: "#",
        content: "We help you market your crops and connect with customers through our platform's built-in marketing tools and promotional opportunities. Easily list your products, manage your inventory, and track your sales with our user-friendly platform. We provide the tools you need to succeed in the online marketplace.",
    },
    {
        title: "Ugah Boogah Vapes",
        description: "Inventory Management System",
        src: ims,
        ctaText: "View Project",
        ctaLink: "#",
        content: "This is an inventory management system for the vape shop called Ugah Boogah Vapes. Automate key processes, improve data flow, and speed up operations with barcode scanner integration across your organization.",
    },
];


export default Projects